import React from "react";

// 頁腳元件
const Footer = ({ t }) => {
  const navigate = (path) => (e) => {
    e.preventDefault();
    window.history.pushState(null, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* 上半部：品牌 + 聯絡 + 導航 */}
        <div className="footer-top">
          {/* 左：品牌 + 聯絡資訊 */}
          <div className="footer-brand-col">
            <div className="footer-brand">VAPOR</div>
            <p className="footer-desc">{t.hero.subtitle}</p>
            {/* 聯絡資訊 */}
            <div className="footer-contact-info">
              <span className="footer-contact-item">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 4L12 13 2 4"/>
                </svg>
                service@getvapor.org
              </span>
            </div>
          </div>

          {/* 右：導航連結 */}
          <div className="footer-nav">
            <div className="footer-col">
              <h4>{t.footer.about}</h4>
              <a href="/changelog" onClick={navigate("/changelog")}>{t.footer.changelog}</a>
              <a href="/privacy-policy" onClick={navigate("/privacy-policy")}>{t.footer.privacyPolicy}</a>
              <a href="/terms" onClick={navigate("/terms")}>{t.footer.terms}</a>
              <a href="/faq" onClick={navigate("/faq")}>{t.footer.faq}</a>
            </div>
            <div className="footer-col">
              <h4>{t.footer.community}</h4>
              <a href="https://github.com/Vapor-web3" target="_blank" rel="noopener noreferrer">GitHub</a>
            </div>
          </div>
        </div>

        {/* 分隔線 */}
        <div className="footer-divider" />

        {/* 底部版權 */}
        <div className="footer-bottom">
          <div className="footer-copy">
            &copy; {new Date().getFullYear()} Vapor. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
